import type { IconProps as _ } from '@chakra-ui/react' // TODO: should be handled in tsconfig
import { BiScreenshot } from 'react-icons/bi'
import { BsStars } from 'react-icons/bs'
import { CgLinear } from 'react-icons/cg'
import { FaJira } from 'react-icons/fa'
import { LuFileJson } from 'react-icons/lu'
import { MdDisplaySettings } from 'react-icons/md'
import {
  PiArchive,
  PiArrowUpRight,
  PiArrowsOutSimple,
  PiArticle,
  PiBroom,
  PiCaretDown,
  PiChartDonut,
  PiChartLineUp,
  PiChatCircle,
  PiChatDots,
  PiCoins,
  PiCopy,
  PiCornersOut,
  PiDatabase,
  PiDotsThree,
  PiFolder,
  PiFolderDashed,
  PiFootball,
  PiFunnel,
  PiGauge,
  PiGear,
  PiGift,
  PiGraph,
  PiHardDrives,
  PiHeadCircuit,
  PiImage,
  PiLayout,
  PiLineSegments,
  PiMagicWand,
  PiMapTrifold,
  PiMinus,
  PiNote,
  PiNotepadLight,
  PiPaintBrushHouseholdLight,
  PiPencilSimple,
  PiPlus,
  PiProjectorScreenChart,
  PiStar,
  PiStarFill,
  PiTarget,
  PiTrash,
  PiUpload,
  PiUsers,
  PiWrench,
  PiX,
  PiChartScatter,
  PiPaperPlaneTilt,
  PiUsersThree,
  PiShapes,
  PiLock,
  PiGlobe,
  PiLink,
  PiPlay
} from 'react-icons/pi'
import { SiAsana, SiGooglesheets } from 'react-icons/si'
import { VscExpandAll, VscCollapseAll, VscTasklist } from 'react-icons/vsc'

import Productboard from '@app/images/productboard'
import Shortcut from '@app/images/shortcut'

const ICON_MAP = {
  AiAssistant: PiChatDots,
  AiCollection: BsStars,
  AiPrompt: PiMagicWand,
  AiTools: PiHeadCircuit,
  AiGraph: PiGraph,
  Asana: SiAsana,
  BasicCard: PiArticle,
  BasicCardList: PiShapes,
  Bet: PiCoins,
  Customer: PiUsersThree,
  Entity: PiWrench,
  GoogleSheets: SiGooglesheets,
  Image: PiImage,
  Jira: FaJira,
  Linear: CgLinear,
  Metric: PiGauge,
  Note: PiNote,
  Playbook: PiFootball,
  PlaybookTemplate: LuFileJson,
  Productboard,
  Section: BiScreenshot,
  Shortcut,
  Strategy: PiMapTrifold,
  StrategyMap: PiMapTrifold,
  StrategyReport: PiProjectorScreenChart,
  Task: VscTasklist,
  Work: PiWrench,

  Comments: PiChatCircle,
  Favorite: PiStar,
  Favorited: PiStarFill,

  CardSize: PiArrowsOutSimple,
  CardSettings: MdDisplaySettings,
  Close: PiX,
  ColorAction: PiPaintBrushHouseholdLight,
  Copy: PiCopy,
  Delete: PiTrash,
  Clear: PiBroom,
  Edit: PiPencilSimple,
  Ellipsis: PiDotsThree,
  MoreOptions: PiCaretDown,
  Refolder: PiFolderDashed,
  Settings: PiGear,
  Play: PiPlay,

  CollapseAction: VscCollapseAll,
  ExpandAction: VscExpandAll,

  LabelAction: PiNotepadLight,

  ExternalLink: PiArrowUpRight,
  Team: PiUsers,

  Details: PiPencilSimple,
  Confidence: PiChartDonut,
  Impact: PiChartLineUp,
  Data: PiHardDrives,
  DataSource: PiDatabase,

  Changelog: PiArchive,
  MapEducation: PiGift,
  OKR: PiTarget,

  AddItem: PiPlus,

  ZoomIn: PiPlus,
  ZoomOut: PiMinus,
  FitView: PiCornersOut,
  ReLayout: PiLayout,
  Send: PiPaperPlaneTilt,

  AnalyzeVariance: PiChartScatter,
  Segment: PiLineSegments,
  Filter: PiFunnel,
  Folder: PiFolder,

  Upload: PiUpload,

  SharingPrivate: PiLock,
  SharingPublic: PiGlobe,
  SharingToken: PiLink
}

export const COLOR_MAP = {
  BasicCard: 'blue.600',
  Entity: 'orange',
  Strategy: 'blue',
  Metric: 'purple',
  Note: 'blue.600',
  Calculated: 'teal',

  AiPrompt: 'blue.600',
  Asana: 'blue.600',
  Bet: 'red',
  Image: 'blue.600',
  Jira: 'blue.600',
  Linear: 'blue.600',

  Playbook: 'blue.600',
  Productboard: 'blue.600',
  Section: 'blue.600',
  Shortcut: 'blue.600',

  StrategyMap: 'blue.600',
  StrategyReport: 'blue.600',
  Work: 'blue.600',

  Comments: 'blue.600',
  Favorite: 'blue.600',
  Favorited: 'blue.600',

  MoreOptions: 'blue.600',
  Close: 'blue.600',
  ColorAction: 'blue.600',

  CollapseAction: 'blue.600',
  ExpandAction: 'blue.600',

  LabelAction: 'blue.600',

  ExternalLink: 'blue.600',
  Team: 'blue.600',

  // Mapped to colorPalette
  'Confidence-at_risk': 'yellow',
  'Confidence-on_track': 'green',
  'Confidence-off_track': 'red',

  WorkflowStateUnstarted: 'yellow',
  WorkflowStateStarted: 'blue',
  WorkflowStateReviewing: 'teal',
  WorkflowStateFinished: 'green'
}

export default ICON_MAP
